import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "Trading", to: "/trading/coffee", match: "/trading" },
  { label: "Wholesale", to: "/wholesale", match: "/wholesale" },
  { label: "Security & Consulting", to: "/security", match: "/security" }
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const scrollToContact = (e) => {
    e.preventDefault();
    setOpen(false);
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const dark = scrolled || location.pathname.startsWith("/spec") || location.pathname.startsWith("/offer"); // solid header on light pages
  const textColor = dark ? "text-[#10271a]" : "text-[#f6f1e7]";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        dark
          ? "bg-[#f6f1e7]/95 backdrop-blur-md shadow-[0_1px_0_rgba(16,39,26,0.08)] py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 flex items-center justify-between">
        <Link to="/trading/coffee" className="flex items-center gap-3 shrink-0" data-testid="header-logo-link">
          <img
            src={dark ? "/logo-trans.png" : "/logo-white.png"}
            alt="Leslie West Africa Trading Company"
            className="h-10 md:h-12 w-auto transition-all duration-500"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((item) => {
            const active = location.pathname.startsWith(item.match);
            return (
              <Link
                key={item.to}
                to={item.to}
                data-testid={`nav-${item.match.slice(1)}`}
                className={`link-underline text-[13px] tracking-[0.14em] uppercase font-medium transition-colors ${textColor} ${
                  active ? "opacity-100" : "opacity-75 hover:opacity-100"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
          <a
            href="#contact"
            onClick={scrollToContact}
            className={`text-[13px] tracking-[0.14em] uppercase font-semibold px-5 py-2.5 rounded-full transition-all duration-300 ${
              dark
                ? "bg-[#1f4a33] text-[#f6f1e7] hover:bg-[#10271a]"
                : "bg-[#f6f1e7] text-[#10271a] hover:bg-white"
            }`}
          >
            Contact
          </a>
        </nav>

        <button
          onClick={() => setOpen((o) => !o)}
          className={`md:hidden ${textColor}`}
          aria-label="Menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden mt-3 mx-4 rounded-2xl bg-[#10271a] text-[#f6f1e7] p-6 shadow-xl">
          <div className="flex flex-col gap-5">
            {NAV.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                data-testid={`mobile-nav-${item.match.slice(1)}`}
                className="text-sm tracking-[0.14em] uppercase font-medium"
              >
                {item.label}
              </Link>
            ))}
            <a
              href="#contact"
              onClick={scrollToContact}
              className="text-sm tracking-[0.14em] uppercase font-semibold bg-[#f6f1e7] text-[#10271a] px-5 py-3 rounded-full text-center"
            >
              Contact
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
